import { render } from "./v-child-add-parent.vue?vue&type=template&id=af8c89d6"
import script from "./v-child-add-parent.vue?vue&type=script&lang=js"
export * from "./v-child-add-parent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__